import React from 'react'

export default function LogisticsRegister() {
  return(
    <div></div>
  )
}
